import React, { useState, useEffect } from "react"
import { Formik, Form, Field, ErrorMessage } from "formik"
import * as Yup from "yup"
import { Col, Row } from "reactstrap"
import Toggle from "react-toggle"
import "react-toggle/style.css"
import {
  Fn_AddEditData,
  Fn_DisplayData,
  Fn_FillListData,
  Fn_GetReport,
} from "../../store/Functions"
import { useDispatch } from "react-redux"
import { API_WEB_URLS } from "../../constants/constAPI"
import { useLocation } from "react-router-dom"
import DynamicTable from "./DynamicTable"

function AddEdit_PlanL() {
  const API_URL = API_WEB_URLS.MASTER + "/0/token/PlanMaster"
  const API_URL2 = API_WEB_URLS.MASTER + "/0/token/Periodicity"
  const API_URL3 = API_WEB_URLS.MASTER + "/0/token/UserType"
  const API_URL4 = API_WEB_URLS.SearchPlan + "/0/token"
  const API_URL_SAVE = API_WEB_URLS.PlanL + "/0/token"
  const API_URL_EDIT = API_WEB_URLS.MASTER + "/0/token/PlanL/Id"

  const [state, setState] = useState({

    id: 0,
    FillArray: [],
    FillArray2 : [],
    PeriodArray: [],
    TableArr: [],
    formData: {
      IsGst: false,
      IsTds: false,
    },
    OtherDataScore: [],
    isProgress: true,
    
  })
  const [SearchState,setSearchState] = useState({F_UserType : 0, F_PlanH: 0, F_Periodicity:0})
  // const [TableArr,setTableArr] = useState([])
  
  const CalculationType = [
    { Id: 1, Name: 'Percent' },
    { Id: 2, Name: 'Flat' },
  ]
  
  const dispatch = useDispatch()
  const location = useLocation()

  useEffect(() => {
    Fn_FillListData(dispatch, setState, "FillArray", API_URL + "/Id/0")
    Fn_FillListData(dispatch, setState, "PeriodArray", API_URL2 + "/Id/0")
    Fn_FillListData(dispatch, setState, "FillArray2", API_URL3 + "/Id/0")

    const Id = (location.state && location.state.Id) || 0

    if (Id > 0) {
      setState(prevState => ({
        ...prevState,
        id: Id,
      }))
      Fn_DisplayData(dispatch, setState, Id, API_URL_EDIT)
    }
  }, [dispatch, location.state])

  const SearchPlan = (e) => {
    const { name, value } = e.target;
    console.log(name,value)
 
      setState(prevState => ({
        ...prevState,
        formData: {
            ...prevState.formData,
            [name]: value,
        }
    }));

  };
  useEffect(()=>{
    let vformData = new FormData();
    vformData.append("F_UserType", state.formData.F_UserType || 0);
    vformData.append("F_PlanH", state.formData.F_PlanH || 0 );
    vformData.append("F_Periodicity", state.formData.F_Periodicity || 0);

    Fn_GetReport(dispatch, setState, "TableArr", API_URL4,  { arguList: { id: 0, formData: vformData }}, true);

  },[state.formData.F_UserType ,state.formData.F_PlanH,state.formData.F_Periodicity ])

  const validationSchema = Yup.object({
    F_UserType: Yup.string().required("UserType is required"),
    F_PlanH: Yup.string().required("Plan is required"),
    F_Periodicity: Yup.string().required("Periodicity is required"),
    TimePeriod: Yup.string().required("TimePeriod is required"),
    Price: Yup.string().required("Price is required"),
    CalculationType: Yup.string().required("CalculationType is required"),
    IsGst: Yup.boolean().required("IsGst is required"),
    IsTds: Yup.boolean().required("IsTds is required"),
  })
  const columnNames = ['UserType', 'PlanMaster', 'Periodicity', 'TimePeriod','IsTds','CalculationType'];

  const rowStyling = (row) => {
    let style = {};
    if (row.PlanMaster === '') {
        style.fontWeight = 'bold';
    }
   
    return style;
};
  const handleSubmit = values => {
    const obj = JSON.parse(localStorage.getItem("authUser"))
    let vformData = new FormData()

    vformData.append("F_PlanH", values.F_PlanH)
    vformData.append("F_UserType ", values.F_UserType)
    vformData.append("F_Periodicity", values.F_Periodicity)
    vformData.append("TimePeriod", values.TimePeriod)
    vformData.append("Price", values.Price)
    vformData.append("CalculationType", values.CalculationType)
    vformData.append("IsGst", values.IsGst ? 1:2)
    vformData.append("IsTds", values.IsTds? 1:2)
    vformData.append("UserId", obj.uid)

    Fn_AddEditData(
      dispatch,
      setState,
      { arguList: { id: state.id, formData: vformData } },
      API_URL_SAVE,
      true,
      "memberid"
    )
  }

  return (
    <div className="page-content">
      <Formik
        initialValues={state.formData}
        enableReinitialize={true}
        validationSchema={validationSchema}
        onSubmit={values => {
          handleSubmit(values)
        }}
      >
        {({ setFieldValue, values }) => (
          <Form className="form-horizontal">
          <Row>
            <Col lg='2' className="mb-3">
              <label htmlFor="F_UserType" className="form-label">UserType</label>
              </Col>
                
                <Col lg='4'>
              <Field className="form-control" as="select" name="F_UserType"     onChange={(e) => SearchPlan(e)}>
                <option value="">Select UserType</option>
                {state.FillArray2.map((UserType) => (
                  <option key={UserType.Id} value={UserType.Id}>{UserType.Name}</option>
                ))}
              </Field>
              <ErrorMessage name="F_UserType" component="div" className="text-danger"/>
            </Col>
         
              <Col lg="2" className="mb-3">
                <label htmlFor="F_PlanH" className="form-label">
                  Plan
                </label>
                </Col>
                
                <Col lg='4'>
                <Field
                  className="form-control"
                  as="select"
                  name="F_PlanH"
                  onChange={(e) => SearchPlan(e)}
                >
                  <option value="">Select Plan</option>
                  {state.FillArray.map(type => (
                    <option key={type.Id} value={type.Id}>
                      {type.Name}
                    </option>
                  ))}
                </Field>
                <ErrorMessage
                  name="F_PlanH"
                  component="div"
                  className="text-danger"
                />
              </Col>
            </Row>
            <Row>
              <Col lg="2" className="mb-3">
                <label htmlFor="F_Periodicity" className="form-label">
                  Periodicity
                </label>
                </Col>
                
                <Col lg='4'>
                <Field
                  className="form-control"
                  as="select"
                  name="F_Periodicity"
                  onChange={(e) => SearchPlan(e)}
                >
                  <option value="">Select Periodicity</option>
                  {state.PeriodArray.map(type => (
                    <option key={type.Id} value={type.Id}>
                      {type.Name}
                    </option>
                  ))}
                </Field>
                <ErrorMessage
                  name="F_Periodicity"
                  component="div"
                  className="text-danger"
                />
              </Col>
           
              <Col lg="2" className="mb-3">
                <label htmlFor="TimePeriod" className="form-label">
                  Time Period
                </label>
                </Col>
                
                <Col lg='4'>
                <Field className="form-control" type="number" name="TimePeriod" />
                <ErrorMessage
                  name="TimePeriod"
                  component="div"
                  className="text-danger"
                />
              </Col>
            </Row>
            <Row>
              <Col lg="2" className="mb-3">
                <label htmlFor="CalculationType" className="form-label">
                  Calculation Type
                </label>
                </Col>
                
                <Col lg='4'>
                <Field
                  className="form-control"
                  as="select"
                  name="CalculationType"
                >
                  <option value="">Select Calculation Type</option>
                  {CalculationType.map(type => (
                    <option key={type.Id} value={type.Id}>
                      {type.Name}
                    </option>
                  ))}
                </Field>
                <ErrorMessage
                  name="CalculationType"
                  component="div"
                  className="text-danger"
                />
              </Col>
        
              <Col lg="2" className="mb-3">
                <label htmlFor="Price" className="form-label">
                  Price
                </label>
                </Col>
                
                <Col lg='4'>
                <Field className="form-control" type="number" name="Price" />
                <ErrorMessage
                  name="Price"
                  component="div"
                  className="text-danger"
                />
              </Col>
            </Row>
            <Row>
              <Col lg="1" className="mb-3">
                <label htmlFor="IsGst" className="form-label">
                  Is GST
                </label>
                </Col>
                
                <Col lg='2'>
                <Toggle
                  id="IsGst"
                  checked={values.IsGst}
                  onChange={() => setFieldValue("IsGst", !values.IsGst)}  
                />
                <ErrorMessage
                  name="IsGst"
                  component="div"
                  className="text-danger"
                />
              </Col>
         
              <Col lg="1" className="mb-3">
                <label htmlFor="IsTds" className="form-label">
                  Is TDS
                </label>
                </Col>

                <Col lg='2'>
                <Toggle
                  id="IsTds"
                  checked={values.IsTds}
                  onChange={() => setFieldValue("IsTds", !values.IsTds)}
                />
                <ErrorMessage
                  name="IsTds"
                  component="div"
                  className="text-danger"
                />
              </Col>
            </Row>
            <button type="submit" className="btn btn-primary btn-block">
              Submit
            </button>
          </Form>
        )}
      </Formik>
      {/* <DynamicTable data={dataArray} columns={columnNames} rowStyling={rowStyling} /> */}
      <DynamicTable data={state.TableArr} columns={columnNames}  rowStyling={rowStyling} />
    </div>
  )
}

export default AddEdit_PlanL
